// languageLabels.ts
import {Language} from "@/api/data-contracts";
import {CommonI18N} from "@/translations";

/**
 * Maps each `Language` enum value to its translation key (`common.enum.language.*`).
 * Shared between `LanguageFileManagementPage.tsx` and `I18nImportLogDialog.tsx` so both the
 * language-status table and the import-protocol tables/dialog display the same label.
 */
export const languageLabelKeys: Record<Language, string> = {
    [Language.GERMAN]: CommonI18N.enum.language.GERMAN,
    [Language.ENGLISH]: CommonI18N.enum.language.ENGLISH,
    [Language.POLISH]: CommonI18N.enum.language.POLISH,
    [Language.ITALIAN]: CommonI18N.enum.language.ITALIAN,
    [Language.FRENCH]: CommonI18N.enum.language.FRENCH,
    [Language.CZECH]: CommonI18N.enum.language.CZECH
};

/**
 * Maps each `Language` enum value to its short file code (`DE`/`EN`) used in exported and
 * imported language-file names. Mirrors the backend `Language.getValue()` codes so the
 * client-side download filename matches the backend `Content-Disposition` name and the
 * documented convention (`sprachdatei_DE.xlsx`) — not the raw enum name (`GERMAN`).
 */
export const languageFileCodes: Record<Language, string> = {
    [Language.GERMAN]: "DE",
    [Language.ENGLISH]: "EN",
    [Language.POLISH]: "PL",
    [Language.ITALIAN]: "IT",
    [Language.FRENCH]: "FR",
    [Language.CZECH]: "CS"
};
